export default __webpack_public_path__ + "25f142aae395c2967e69c175718e406a.jpg";